
import { IonContent, IonPage } from "@ionic/react";
import { withRouter } from "react-router";
import Header from "src/components/Header";
import { AsignacionProps } from "src/utils";
import { closeOutline} from "ionicons/icons";
import TablaDT from "../components/asignacion/tabla/TablaDT";



const AsignacionDetalle: React.FC<AsignacionProps> = (
  props: AsignacionProps
) => {
  


  const botonCerrar = {
    icono: closeOutline,
    action: () => props.history.goBack(),
  };

  return (
    <IonPage>
      
      <Header  titulo="Detalle Asignacion" botonIzq={botonCerrar} />
      <IonContent id="asignacion">
        <div className="container">
          <div className="d-flex mt-3 flex-column align-items-center">
            
              
            <TablaDT/>
            
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
  
};

export default withRouter(AsignacionDetalle);
